<template>
  <div class="contact-item" :class="{disabled: isDisabled, 'in-progress': inProgress}">
    <div class="delete-contact" @click="deleteContact" v-if="!isDeleting">
      <img src="../../assets/icon_clear.svg">
    </div>
    <div
      class="call-contact"
      :class="{'is-animating': callLoading === contact.identity, 'contact-has-been-enabled': contactHasBeenEnabled}"
      @click="initiateCall"
    >
      <div class="Phone" :class="{disabled: isDisabled, 'is-animating': callLoading === contact.identity}">
      </div>
    </div>
    <div class="contact-info">
      <span>{{contact.name}}</span>
      <div class="in-progress-label" v-if="inProgress">In progress</div>
      <div class="bg-animation"></div>
    </div>
    <div class="record-checkbox" v-if="!isDisabled" :class="{selected: shouldRecord}" @click="toggleShouldRecord" v-tooltip.right="recordTooltip">
      <img v-if="!shouldRecord" src="../../assets/icon_rec_off.svg" style="height: 38px">
      <img v-if="shouldRecord" src="../../assets/icon_rec_on.svg" style="height: 38px">
    </div>
    <div class="contact-info-button" v-tooltip.right="'Show contact info'" @click="showInfo">
      <fa-icon icon="info-circle" size="lg"/>
    </div>
  </div>
</template>

<script>
  import {mapGetters} from 'vuex';

  export default {
    name: 'ContactItem',
    props: {
      contact: {
        type: Object
      },
      callLoading: {
        type: String
      },
      isDeleting: {
        type: Boolean
      }
    },

    data: () => ({
      shouldRecord: false,
      contactHasBeenEnabled: false
    }),

    computed: {
      ...mapGetters({
        isContactInCall: 'sessions/isContactInCall'
      }),
      isDisabled() {
        return (this.contact.status === 'PENDING'
          && process.env.NODE_ENV === 'production')
          || this.inProgress
      },
      inProgress() {
        return this.isContactInCall(this.contact.id)
      },
      recordTooltip() {
        return this.shouldRecord? 'Disable Recording': 'Enable Recording'
      }
    },

    methods: {
      initiateCall() {
        if (!this.isDisabled && !this.callLoading) {
          this.$emit('call', {contact: this.contact, shouldRecord: this.shouldRecord})
        }
      },
      deleteContact() {
        this.$emit('delete', this.contact)
      },
      toggleShouldRecord() {
        this.shouldRecord = !this.shouldRecord;
      },
      showInfo() {
        this.$emit('showInfo', this.contact)
      }
    },

    watch: {
      contact(newVal, oldVal) {
        if(newVal.status === 'ACCEPTED' && oldVal.status === 'PENDING') {
          this.contactHasBeenEnabled = true
        }
      }
    }
  }
</script>

<style lang="scss">
  @import "ContactItem";
</style>
